<template>
  <div class="main">
    <div class="header">
      <div class="back-icon">
        <img class="back-img" src="~/assets/imgs/backiconblack.png" @click="back" />
      </div>
      <div class="header-title">
        <div class="title">兑换记录</div>
      </div>
    </div>
    <div v-if="isInitLoading" class="loading">
      <van-loading size="16px">加载中...</van-loading>
    </div>
    <div v-else class="context" @scroll="handleScroll">
      <img v-if="orderList.length === 0" class="context-img" src="~/assets/imgs/noresult.png" />
      <div v-else>
        <div v-for="(order, i) in orderList" :key="i" class="list" @click="goDetail(order)">
          <div class="list-img">
            <img :src="order.commodityImg" alt="" />
            <div v-if="order.orderStatus === 'create'" class="status success">创建成功</div>
            <div v-else-if="order.orderStatus === 'waiting_pay'" class="status success">待支付</div>
            <div v-else-if="order.orderStatus === 'pay_exception'" class="status fail">
              支付异常
            </div>
            <div v-else-if="order.orderStatus === 'sending'" class="status success">发货中</div>
            <div v-else-if="order.orderStatus === 'send_fail'" class="status fail">发货失败</div>
            <div v-else-if="order.orderStatus === 'send_success'" class="status success">
              发货成功
            </div>
            <div v-else-if="order.orderStatus === 'refunding'" class="status fail">退款中</div>
            <div v-else-if="order.orderStatus === 'refund_success'" class="status success">
              退款成功
            </div>
            <div v-else-if="order.orderStatus === 'refund_fail'" class="status fail">退款异常</div>
            <div v-else-if="order.orderStatus === 'pay_timeout'" class="status warn">支付超时</div>
            <div v-else-if="order.orderStatus === 'invalid'" class="status warn">已失效</div>
            <div v-else class="status success">无状态</div>
          </div>
          <div class="list-right">
            <div class="name">{{ order.commodityName }}</div>
            <div class="time">{{ formatTimestamp(order.createTime) }} 兑换</div>
            <div class="count">
              <div>兑换数量：{{ order.paymentNum }}</div>
              <div class="count-right">
                <img
                  v-if="order.paymentType === 'member_free'"
                  src="~/assets/imgs/member_icon.png"
                />
                <span v-if="order.paymentType === 'lecoin'">-{{ order.paymentPrice }}乐币</span>
                <span v-if="order.paymentType === 'member_free'">会员免费</span>
                <span v-if="order.paymentType === 'free'">免费</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="loading" class="loading">
          <van-loading size="16px">加载中...</van-loading>
        </div>
        <div v-if="orderList.length == total" class="desc">超过120天的兑换记录会被清除</div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { showToast } from "vant";
import { defineEmits } from "vue";
import { useRouter } from "vue-router";
import { getOrderList } from "~/business/alova/methods/goodsPageApi.ts";
import { useRequest } from "alova";

const router = new useRouter();
const emit = defineEmits(["close"]);
const total = ref(0);
const orderList = ref([]);
const loading = ref(false);
const isInitLoading = ref(true);

/**
 * @description 判断滚动条到地步
 * @param {Object} event 参数
 * @return {void}
 */
const handleScroll = (event) => {
  const { scrollTop, clientHeight, scrollHeight } = event.target;
  if (scrollTop + clientHeight >= scrollHeight) {
    if (orderList.value.length >= total.value) return;
    pageNum.value++;
    getOrders();
  }
};
/**
 * @description 时间格式化
 * @param {number} timestamp 参数
 * @return {void}
 */
const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  const year = date.getFullYear(); // 年
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 月（从 0 开始，需要加 1）
  const day = String(date.getDate()).padStart(2, "0"); // 日
  const hours = String(date.getHours()).padStart(2, "0"); // 小时
  const minutes = String(date.getMinutes()).padStart(2, "0"); // 分钟
  return `${year}-${month}-${day} ${hours}:${minutes}`;
};
/**
 * @description 返回个人中心
 * @return {void}
 */
const back = () => {
  emit("close");
};
/**
 * @description 跳转到详情页
 * @param {Object} order 参数
 * @return {void}
 */
const goDetail = (order) => {
  if (order.commodityStatus === "normal") {
    sessionStorage.setItem("commodityId", order.commodityId);
    sessionStorage.setItem("detailFrom", "main");
    router.push(`/goodsdetailisr/${order.commodityId}`);
  } else {
    showToast("商品已下架，无法跳转");
  }
};
const pageNum = ref(1);
/**
 * @description 获取订单列表
 * @return {void}
 */
const getOrders = () => {
  loading.value = true;
  const { data, onSuccess ,onComplete} = useRequest(()=>{return getOrderList(pageNum.value)})
  onSuccess((res)=>{
    const data = res?.data?.data?.dataList || [];
    orderList.value.push(...data);
    total.value = res?.data?.data?.total || 0;
  })
  onComplete(()=>{
    loading.value = false;
    isInitLoading.value = false;
  })
};
onMounted(() => {
  getOrders();
});
</script>
<style scoped lang="scss">
.main {
  height: calc(100vh - 1.6rem);
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background: #f5f5f5;
  .header {
    position: sticky;
    top: 0;
    background: #fff;
    padding-top: 1.6rem;
    .header-title {
      height: 2.5rem;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .title {
        width: 3rem;
        font-weight: 600;
        font-size: 0.72rem;
        text-align: center;
        color: #000;
      }
    }
    .back-icon {
      width: 1.067rem;
      height: 2.5rem;
      position: absolute;
      margin-left: 0.7rem;
      .back-img {
        margin-top: 1.25rem;
        transform: translateY(-50%);
      }
    }
  }
  .loading {
    display: flex;
    justify-content: center;
    padding-top: 1rem;
  }
  .context {
    width: 16rem;
    height: calc(100vh - 2.5rem - 1.6rem);
    overflow-y: scroll;
    background: #f5f5f5;
    padding: 0.71rem 0;
    .desc {
      font-size: 0.53rem;
      color: #999;
      text-align: center;
    }
    .context-img {
      width: 5rem;
      height: 5rem;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .list {
      height: 4rem;
      width: 14.5rem;
      border-radius: 0.4rem;
      margin: 0 auto 0.34rem auto;
      padding: 0 0.29rem;
      background: #fff;
      position: relative;
      display: flex;
      align-items: center;
      .list-img {
        width: 5.67rem;
        height: 3.54rem;
        border-radius: 0.4rem;
        margin-right: 0.4rem;
        position: relative;
        img {
          width: 5.67rem;
          height: 3.54rem;
          border-radius: 0.4rem;
        }
        .status {
          position: absolute;
          left: 0;
          top: 0rem;
          width: 3.28rem;
          height: 0.9rem;
          line-height: 0.9rem;
          text-align: center;
          font-size: 0.53rem;
          border-radius: 0.4rem 0 0.4rem 0;
          color: #fff;
        }
        .success {
          background: #ff7210;
        }
        .fail {
          background: #ff3b10;
        }
        .warn {
          background: #ccc;
        }
      }
      .list-right {
        flex: 1;
      }
      .name {
        font-size: 0.62rem;
        color: #333;
        height: 1.7rem;
        overflow: hidden; /* 隐藏超出部分 */
        display: -webkit-box; /* 使用 WebKit 盒模型 */
        -webkit-line-clamp: 2; /* 设置最大显示行数为两行 */
        -webkit-box-orient: vertical; /* 设置盒模型的方向为垂直 */
        text-overflow: ellipsis; /* 显示省略号 */
      }
      .time {
        font-size: 0.53rem;
        color: #999;
        margin: 0.18rem 0;
      }
      .count {
        font-size: 0.53rem;
        color: #999;
        display: flex;
        justify-content: space-between;
        img {
          display: inline-block;
          width: 0.45rem;
          height: 0.45rem;
        }
        .count-right {
          color: #ff7210;
        }
      }
    }
  }
}
</style>
